<template>
	<div>
		<header>
			<div style="display: block;">
				<div class="cu-custom" style="height: 45px;">
					<div class="cu-bar fixed bg-gradual-black" style=" height: 45px; padding-top: 0px;">
						<div class="content text-gold" style="top: 0px;">
							<div>{{$t('jiaoyiguize')}}</div>
						</div>
						<div class="action" @click="changego">
							<text class="cuIcon-back" style="width: 50px;">
								<span></span>
							</text>
						</div>
					</div>
				</div>
			</div>
		</header>
		<div class="cu-list menu">
			<div data-code="GAME_RULES" class="cu-item bg-gradual-black" @click="changeText">
				<div class="content">
					<text class="cuIcon-questionfill  text-gold">
						<span></span>
					</text>
					<text class=" text-gold">
						<span style="margin-right: 190px;">{{$t('text')}}</span>
					</text>
					<text style="float: right;" class="iconfont icon-right text-gold">
						<van-icon name="arrow" />
						<span></span>
					</text>
				</div>
			</div>
			<div data-code="NASDAQ_DETAIL" class="cu-item bg-gradual-black" @click="changeNasd">
				<div class="content">
					<text class="cuIcon-questionfill text-gold">
						<span></span>
					</text>
					<text class="text-gold">
						<span style="margin-right: 42%;">{{$t('nasd')}}</span>
					</text>
					<text style="float: right;" class="iconfont icon-right text-gold">
						<van-icon name="arrow" />
						<span></span>
					</text>
				</div>
			</div>
			<div data-code="USA_DETAIL" class="cu-item bg-gradual-black" @click="changeUsa">
				<div class="content">
					<text class="cuIcon-questionfill text-gold">
						<span></span>
					</text>
					<text class="text-gold">
						<span style="margin-right: 190px;">{{$t('usa')}}</span>
					</text>
					<text class="iconfont icon-right text-gold" style="float: right;">
						<van-icon name="arrow" />
						<span></span>
					</text>
				</div>
			</div>
			<div data-code="LSE_DETAIL" class="cu-item bg-gradual-black" @click="changeLdn">
				<div class="content">
					<text class="cuIcon-questionfill text-gold">
						<span></span>
					</text>
					<text class="text-gold">
						<span style="margin-right: 190px;">{{$t('ldn')}}</span>
					</text>
					<text class="iconfont icon-right text-gold" style="float: right;">
						<van-icon name="arrow" />
						<span></span>
					</text>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "Rule",
		components: {},
		data() {
			return {};
		},
		methods: {
			changego() {
				this.$router.go(-1);
			},
			changeText() {
				this.$router.push({
					path: "/text",
				});
			},
			changeNasd() {
				this.$router.push({
					path: "/Nasd",
				});
			},	
				changeUsa() {
				this.$router.push({
					path: "/Usa",
				});
			},
			changeLdn() {
				this.$router.push({
					path: "/Ldn",
				});
			},
		}
	};
	
</script>

<style>
	.cu-custom {
		display: block;
		position: relative;
		box-sizing: border-box;
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-bar .content {
		position: absolute;
		text-align: center;
		width: calc(100% - 194px);
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		margin: auto;
		height: 34px;
		font-size: 17px;
		line-height: 34px;
		cursor: none;
		pointer-events: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.cu-bar .action>text[class*="cuIcon-"],
	.cu-bar .action>div[class*="cuIcon-"] {
		font-size: 20px;
	}

	.cu-bar {
		display: flex;
		position: relative;
		align-items: center;
		min-height: 57px;
		justify-content: space-between;
	}

	.cu-bar.fixed,
	.nav.fixed {
		position: fixed;
		width: 100%;
		top: 0;
		z-index: 1024;
		box-shadow: 0 0.5px 3px rgba(0, 0, 0, .1);
	}

	.cu-custom .cu-bar {
		min-height: 0;
		box-shadow: 0px 0px 0px;
		z-index: 9999;
	}

	.cu-custom .cu-bar .content {
		width: calc(100% - 252px);
	}

	.cu-bar .action {
		display: flex;
		align-items: center;
		height: 100%;
		justify-content: center;
		max-width: 100%;
	}

	.cuIcon-back:before {
		content: "\e679";
	}

	.cu-list.menu {
		display: block;
		overflow: hidden;
	}

	.cu-list.menu>.cu-item {
		position: relative;
		display: flex;
		padding: 0 17px;
		min-height: 57px;
		background-color: #fff;
		justify-content: space-between;
		align-items: center;
	}

	.cu-list>.cu-item {
		transition: all .6s ease-in-out 0s;
		-webkit-transform: translateX(0px);
		transform: translateX(0px);
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-list.menu>.cu-item .content {
		font-size: 17px;
		line-height: 1.6em;
		flex: 1;
	}

	.cu-list.menu>.cu-item .content>text[class*=cuIcon] {
		display: inline-block;
		margin-right: 5px;
		width: 1.6em;
		text-align: center;
	}

	[class*="cuIcon-"] {
		font-family: cuIcon;
		font-size: inherit;
		font-style: normal;
	}

	.text-gold,
	.line-gold,
	.lines-gold {
		color: #b8a78a;
	}

	.cuIcon-questionfill:before {
		content: "\e690";
	}


	.cu-list.menu-avatar>.cu-item:after,
	.cu-list.menu>.cu-item:after {
		position: absolute;
		top: 0;
		left: 0;
		box-sizing: border-box;
		width: 200%;
		height: 200%;
		border-bottom: 0.5px solid #ddd;
		border-radius: inherit;
		content: " ";
		-webkit-transform: scale(.5);
		transform: scale(.5);
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
		pointer-events: none;
	}

	body {
		background-color: #f1f1f1;
		font-size: 16px;
		color: #333;
		font-family: Helvetica Neue, Helvetica, sans-serif;
	}
</style>